/** List of CENTROes */
export const GET_CENTROS_LIST_REQUEST = 'GET_CENTROS_LIST_REQUEST';
export const GET_CENTROS_LIST_SUCCESS = 'GET_CENTROS_LIST_SUCCESS';

/** CENTROS form */
export const SET_CENTRO_REQUEST = 'SET_CENTRO_REQUEST';
export const SET_CENTRO_SUCCESS = 'SET_CENTRO_SUCCESS';
export const GET_CENTROS_MODAL = 'GET_CENTROS_MODAL';
export const HIDE_CENTROS_MODAL = 'HIDE_CENTROS_MODAL';

/** Error */
export const GET_CENTROS_ERROR = 'GET_CENTROS_ERROR';